import './static/css/compiled-tailwind.min.css';
import 'sal.js/dist/sal.css';
import sal from 'sal.js';

export const onInitialClientRender = () => {
	sal({
		threshold: 1,
		once: true,
		disabled: false,
		selector: '[data-sal]',
		animateClassName: 'sal-animate',
		disabledClassName: 'sal-disabled',
		rootMargin: '0% 50%'
	});
};
